module.exports = ".img-targetit {\n  max-height: 25px;\n}\n\n.navbar {\n  margin-bottom: 0;\n}"